"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var SvgTeamsMeeting = function (props) { return (React.createElement("svg", __assign({ "data-testid": "ICON_TEAMS-MEETING", width: "1em", height: "1em", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { d: "M9.6 5.8a2.4 2.4 0 1 0-2.4-2.4H.8c-.44 0-.8.36-.8.8v8c0 .44.36.8.8.8h4.984a3.53 3.53 0 0 0 3.344 2.4h.144c1.455 0 2.704-.88 3.243-2.138.316.18.691.234.98.234 1.383 0 2.505-1.028 2.505-2.296V7.289c0-.38-.337-.689-.751-.689H9.6v-.8Zm1.6-2.4c0 .882-.717 1.6-1.6 1.6v-.8c0-.44-.36-.8-.8-.8H8c0-.883.719-1.6 1.6-1.6.883 0 1.6.717 1.6 1.6Zm-6.025 7.9H3.636V6.644H1.895V5.1h5.01v1.544h-1.73V11.3Zm6.824.605c-.002.02-.003.043-.002.066a2.732 2.732 0 0 1-2.726 2.63h-.144A2.732 2.732 0 0 1 6.643 13h2.156c.44 0 .8-.36.8-.8V7.4h2.4v4.504Zm3.2-.705c0 .825-.764 1.496-1.704 1.496-.086 0-.467-.011-.668-.191a3.373 3.373 0 0 0-.016-.339l-.002-.027-.003-.033a1.881 1.881 0 0 1-.009-.114l.003-.12V7.4h2.4v3.8Zm.163-7a.96.96 0 1 0-1.922.002.96.96 0 0 0 1.922-.002ZM14.4 2.6a1.6 1.6 0 1 1 0 3.2 1.6 1.6 0 0 1 0-3.2Z" }))); };
exports.default = SvgTeamsMeeting;
